import styled from 'styled-components';

import {
  red,
  green,
  lightGray,
  lighterYellow,
  yellow,
  gray,
  orange,
  whitesmoke,
  boxShadow1,
  black,
  border1,
} from 'utils/style/colors';

import Button from 'components/Button';
import Input from '../../../components/Input/Input';
import { redPulse } from 'utils/style/animations';
import Icon from '../../../components/Icon/Icon';

interface IContainerProps {
  halve: boolean;
}

interface IDateSpan {
  clickable: boolean;
  notValid?: boolean;
}

export const TaskBody = styled.div`
  flex: 1;
  display: flex;
  overflow: auto;
  flex-direction: column;
`;

export const Tasks = styled('section')`
  display: flex;
  min-height: 0;
  flex: 1;
  height: 100%;
`;

export const Container = styled('div')<IContainerProps>`
  flex: 1;
  width: ${(props) => (props.halve ? '50%' : '100%')};
  height: 100%;
  display: flex;
  padding: 1rem !important;
  min-width: 0;
  box-shadow: ${(props) => (props.theme.direction === 'rtl' ? '2px' : '-2px')}
    2px 1rem ${gray};
  overflow: hidden;
  border-radius: 1.5rem;
  transition: all 1s ease;
  flex-direction: column;
  background-color: var(--exact-white);
  z-index: 1;
  @media only screen and (max-width: 1100px) {
    display: ${(props) => (props.halve ? 'none' : 'flex')};
    border-radius: 0;
    box-shadow: none;
  }
`;
export const SubTaskListWrapper = styled('div')<IContainerProps>`
  position: relative;
  flex: 1;
  width: ${(props) => (props.halve ? '50%' : '100%')};
  display: flex;
  padding: 0 !important;
  min-width: 0;
  box-shadow: ${boxShadow1};
  overflow: visible;
  border-radius: 15px;
  transition: all 1s ease;
  flex-direction: column;
  background-color: var(--exact-white);
  //margin: 3rem 0;
`;
interface HighlightOverlayProps {
  visible: boolean;
}
export const HighlightOverlay = styled.div<HighlightOverlayProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${yellow};
  opacity: 0;
  border-radius: 15px;
  z-index: 9999;
  pointer-events: none;
  transition: opacity 0.5s ease; /* Smooth fade-in and fade-out */

  /* Visible state for fading in */
  ${({ visible }) =>
    visible &&
    `
    opacity: 0.5; /* Semi-transparent yellow */
  `}
`;

export const Header = styled('div')`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 0.5em;
  //border-bottom: 1px solid #eee;
  width: 100%;
`;
interface TaskListProp {
  allowAdd?: boolean;
}
export const List = styled('ul')<TaskListProp>`
  position: relative;
  overflow: ${({ allowAdd }) => (allowAdd ? 'visible' : 'auto')};
  margin-block-start: 0;
  margin-block-end: 0;
  flex-grow: 1;
  width: 100%;
  padding: 0 1rem;
`;

export const SearchWrapper = styled('section')`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 1em;
`;

export const ListOptions = styled('div')`
  display: flex;
  float: left;
  align-items: center;
  position: relative;
  padding: 0 0em;
`;

export const TaskInfoRadio = styled('p')`
  margin-top: 4px;
  margin-bottom: 4px;
`;

export const TaskInfoBox = styled('div')`
  background-color: ${whitesmoke};
  display: block;
  font-size: 13px;
  justify-content: space-between;
  align-items: center;
`;
export const TaskDraftBox = styled('div')`
  background-color: var(--exact-white);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3E%3Cg fill='%23E5CE4F' fill-opacity='0.2'%3E%3Cpath fill-rule='evenodd' d='M0 0h4v4H0V0zm4 4h4v4H4V4z'/%3E%3C/g%3E%3C/svg%3E");
  display: block;
  justify-content: space-between;
  align-items: center;
  border-radius: 1rem;
  padding: 1rem;
  margin: 1rem;
  color: ${black};
`;

export const TaskDependencyNotMeetBox = styled('div')`
  color: ${black};
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3E%3Cg fill='${orange}' fill-opacity='0.2'%3E%3Cpath fill-rule='evenodd' d='M0 0h4v4H0V0zm4 4h4v4H4V4z'/%3E%3C/g%3E%3C/svg%3E");
  padding: 1rem;
  font-weight: 600;
  border-radius: 1rem;
  margin: 1rem;
`;

interface EditorContainerProps {
  stickToSide: boolean;
}
export const EditorContainer = styled('div')<EditorContainerProps>`
  flex: 1;
  display: flex;
  padding: 0 !important;
  min-height: 0;
  flex-direction: column;
  background-color: var(--exact-white);
  transition: width 1s;
  border-radius: ${({ stickToSide }) =>
    stickToSide ? '0 15px 15px 0' : '15px'};
  box-shadow: ${boxShadow1};
  height: 100%;
  overflow-y: hidden;
  @media only screen and (max-width: 600px) {
    border-radius: 0;
    min-width: auto;
    //box-shadow: none;
    //margin-right: 0;
    //margin-left: 5px;
    //margin-bottom: 10px;
  }
`;

export const DateContainer = styled('div')`
  display: flex;
  align-items: center;
  margin: 0.2em 0;
  min-width: 10rem;
  width: 100%;
`;

export const DateSpan = styled('div')<IDateSpan>`
  color: ${(props) => (props.notValid ? red : black)};
  //background-color: whitesmoke;
  //border: 1px solid white;
  border-radius: 5em;
  padding: 0;
  margin: 0 0.2em;
  transition: all 0.3s ease;
  //height: 35px;
  cursor: ${(props) => (props.clickable ? 'pointer' : 'default')};
  :hover {
    border-color: ${(props) =>
      props.clickable ? 'silver' : 'var(--exact-white)'};
  }
  width: 100%;
`;

export const LoadingParent = styled('div')`
  margin: 2em;
`;

export const AddSubTaskBtn = styled(Button)`
  margin: 1rem;
  .icon {
    margin-right: 8px;
  }
`;

export const SaveTaskActions = styled('div')`
  margin-top: 1rem;
  padding: 1rem;
  background-color: ${lighterYellow};
  border-radius: 10px;
  margin-bottom: ${(props: any) =>
    props.isCreating ? '3rem' : '0'} !important;

  & > * {
    margin-top: 8px;
  }
  & .row > div {
    float: ${(props) => (props.theme.direction === 'rtl' ? 'right' : 'left')};
  }
`;
export const ButtonActions = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;

export const UsersList = styled('div')`
  position: relative;
  margin: 0.5rem 0;
`;

export const ProgressButton = styled('span')`
  border-radius: 10px;
  background: ${whitesmoke};
  color: ${green};
  display: inline-flex;
  font-size: 0.8rem;
  align-items: stretch;
  font-weight: 500;
  line-height: 2rem;
  margin: 3px;
  padding: 0 0.5rem;
  cursor: pointer;
  transition: 0.3s all ease;
  border: ${border1};
  :hover {
    border: ${border1};
  }
`;

export const WeightInput = styled(Input)`
  //display: 'flex';
`;

export const TaskFooter = styled('div')`
  margin-top: 3rem;
  border-top: 1px solid ${lightGray};
  font-size: 0.8rem;
  color: ${black};
`;

export const Mic = styled(Icon)`
  width: 20px;
  height: 20px;
  padding: 5px;
  color: ${red};
  cursor: pointer;
  box-shadow: 0 0 0 rgba(0, 112, 224, 0.4);
  border-radius: 50%;
`;

export const ActiveMic = styled(Mic)`
  animation: ${redPulse} 1s infinite;
`;

export const Background = styled.div`
  pointer-events: none;
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: ${(props) => (props.theme.direction === 'rtl' ? '0' : undefined)};
  right: ${(props) => (props.theme.direction === 'ltr' ? '0' : undefined)};
  top: 0;
  transition: background-color 2000ms ease-in-out;
  background-color: rgba(130, 130, 130, 0.47);
  @media only screen and (max-width: 600px) {
    background-color: transparent;
  }
  z-index: 2000;
  //opacity: 0.5;
`;

export const InputValueWrapper = styled.div`
  border-radius: 10px;
  border: ${border1};
  padding: 2px;
  margin: 2px;
  min-height: 32px;
`;

export const AlertContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
